
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forms/[handle]/[id]",
      function () {
        return require("private-next-pages/forms/[handle]/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forms/[handle]/[id]"])
      });
    }
  